import React from 'react';
type RatingProofProps = {
  tone?: 'light' | 'dark';
};

/**
 * The three wind versions every Lesson Card comes in.
 * (Replaces the star rating: put real buyer ratings here once they exist.)
 */
const winds = [{
  label: 'Light Air',
  dot: 'bg-sage'
}, {
  label: 'Right Air',
  dot: 'bg-sky'
}, {
  label: 'Wrong Air',
  dot: 'bg-rose'
}];
export function RatingProof({
  tone = 'light'
}: RatingProofProps) {
  const isDark = tone === 'dark';
  return <div className={`text-center text-[13px] leading-tight ${isDark ? 'text-white/75' : 'text-navy-soft'}`} data-id="element-224" data-mp="3ligczmixavjz">
      <ul className="flex flex-wrap justify-center gap-1.5" data-id="element-225" data-mp="3pjtitwm0myqw">
        {winds.map(w => <li key={w.label} className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold ${isDark ? 'bg-white/10 text-white ring-1 ring-white/15' : 'bg-paper text-navy ring-1 ring-paper-dark'}`} data-id="element-226" data-mp="3uez2eory41bt">
            <span className={`h-2 w-2 rounded-full ${w.dot}`} data-id="element-227" data-mp="252dq60e81sw8" />
            {w.label}
          </li>)}
      </ul>
      <p className="mt-2" data-id="element-228" data-mp="1ee4z9nh11087">
        <span className={`font-semibold ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-229" data-mp="19l1zgxlnoujk">One lesson, three winds.</span>{' '}
        Same learning goal in each.
      </p>
    </div>;
}